import { useHistory } from 'react-router-dom';
import storage from '../../../../../hooks/useStorage/useStorage';
import PATHS from '../../../../../routes/routes.const';
import { useAuthContext } from '../../../../login/AuthContext';
import { useNetworkContext } from '../../../contexts/network/network.context';
import useCanEnterInOfflineMode from '../../../hooks/useCanEnterInOfflineMode';
import { useOfflineDataDownloader } from '../../../hooks/useOfflineDataDownloader/useOfflineDataDownloader';

const useOfflineWithoutDataPage = () => {
  const history = useHistory();
  const { loggedin } = useAuthContext();
  const { setIsForcingOfflineMode, isForcingOfflineMode } = useNetworkContext();
  const { canEnterInOfflineMode } = useCanEnterInOfflineMode();
  const { hasSyncedData } = useOfflineDataDownloader();

  const reloadPage = () => {
    setIsForcingOfflineMode({ forceOfflineMode: false });
  };

  const goToOfflineMode = () => {
    if (isForcingOfflineMode) {
      history.replace(PATHS.offline.orders.path);
      return;
    }

    setIsForcingOfflineMode({ forceOfflineMode: true });
  };

  return {
    hasSyncedData,
    canEnterInOfflineMode,
    hasOfflineModeAction: loggedin && hasSyncedData,
    hasBrandBanner: !hasSyncedData && storage.getLastLoginWasFromBrand(),
    reloadPage,
    goToOfflineMode,
  };
};

export default useOfflineWithoutDataPage;
